import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';

export const StyledCircularChip = styled(Chip)`
  margin-left: ${({ theme }) => theme.spacing(1)};
  margin-bottom: 0;
  padding: 0;
  color: ${({ theme }) => theme.palette.text.primary};
  background: ${({ theme }) => theme.palette.background.grayLight};
  max-width: fit-content;

  &:hover,
  &:focus {
    background: ${({ theme }) => theme.palette.background.boxDarkest};
  }
`;

// there is nothing to test here so we exclude this component from the coverage
// istanbul ignore next
export const StyledRectangularChip = styled(Box)`
  background-color: ${({ theme }) => theme.palette.divider};
  border-radius: 50px;
  color: ${({ theme }) => theme.palette.text.secondary};
  display: inline-block;
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  margin: ${({ theme }) => theme.spacing(1, 0)};
  padding: ${({ theme }) => theme.spacing(0, 1.25)};
`;
